import { MutationFunctionOptions } from '@apollo/client';
import { cloneDeep } from 'lodash';

import { readUserPlaylistFragment, readVideoFragment, writeUserPlaylistFragment, writeVideoFragment } from 'src/app/helpers/graphql';

export function getAddVideoToPlaylistOptions(videoId: string, playlistId: string): MutationFunctionOptions {
  return {
    update: (store, { data }) => {
      const videoFragment = readVideoFragment(store, videoId);
      if (data && videoFragment) {
        writeVideoFragment(store, {
          ...videoFragment,
          inPlaylists: data.addVideoToPlaylist.inPlaylists
        });
      }
    },
    variables: {
      playlistId,
      videoId
    }
  };
}

export function getRemoveVideoFromPlaylistOptions(videoId: string, playlistId: string): MutationFunctionOptions {
  return {
    update: (store, { data }) => {
      const videoFragment = readVideoFragment(store, videoId);
      if (data && videoFragment) {
        writeVideoFragment(store, {
          ...videoFragment,
          inPlaylists: data.removeVideoFromPlaylist.inPlaylists
        });
      }
    },
    variables: {
      playlistId,
      videoId
    }
  };
}

export function createPlaylistMutationOptions(name: string): MutationFunctionOptions {
  return {
    update: (store, { data }) => {
      const userFragment = readUserPlaylistFragment(store);
      if (data && userFragment) {
        const cloneData = cloneDeep(userFragment);
        const userPlaylistsFragment = cloneData.playlists ?? [];
        writeUserPlaylistFragment(store, userPlaylistsFragment.concat(data.createPlaylist));
      }
    },
    variables: {
      name
    }
  };
}
